import { createAction, createReducer } from '@reduxjs/toolkit';

export interface DrawersState {
  filterDrawerOpen: boolean;
  careInformationDrawerOpen: boolean;
  activityReviewDrawerOpen: boolean;
}
const drawersState: DrawersState = {
  filterDrawerOpen: false,
  careInformationDrawerOpen: false,
  activityReviewDrawerOpen: false,
};

export const toggleFilterDrawer = createAction<boolean>('drawer/toggleFilterDrawer');
export const toggleCareInformationDrawer = createAction<boolean>('drawer/toggleCareInformationDrawer');
export const toggleActivityReviewDrawer = createAction<boolean>('drawer/toggleActivityReviewDrawer');
const drawersReducer = createReducer(drawersState, (builder) => {
  builder
    .addCase(toggleFilterDrawer, (state, action) => {
      state.filterDrawerOpen = action.payload;
    })
    .addCase(toggleCareInformationDrawer, (state, action) => {
      state.careInformationDrawerOpen = action.payload;
    })
    .addCase(toggleActivityReviewDrawer, (state, action) => {
      state.activityReviewDrawerOpen = action.payload;
    });
});

export default drawersReducer;
